export const colors = {
  black: "#000",
  cyan: "#37D6D6",
  teal: "#069898",
  tealGray: "#A6A9C2",
  dark: "#35311C",
  bege: "#C5C5C5",
  begeLight: "#EDECE5",
  yellow: "#fdd51d",
  yellowLight: "#F8F5EA",
  gray: "#F5F5F5",
  grayLight: "#F0F0F0",
  grayLight1: "#DEDEDE",
  grayLight2: "#C4C4C4",
  grayLight3: "#D5D5D5",
  light: "#7D8D90",
  white: "#fff",
  primary: "#074B5B",
  secundary: "#1EA6C3",
  danger: "#FF4367",
  success: "#5DB94B",
  disable: "#EBEBEB",
};
